import React from "react";

import { HStack } from "../../../primitive";
import { PhoneInputProps } from "../../Input/types";
import { SubtleInput } from "../../SubtleInput";
import { usePhoneInput } from "../hooks/usePhoneInput";
import { CountryCodes } from "../utils/countryCodes";
import { CountryCodeSelector } from "./CountryCodeSelector";

export const SubtlePhoneInput = ({
  testID,
  name,
  placeholder,
  hasError,
  isDisabled,
  onChange,
  inputRef,
  nationalNumber,
  defaultCountryId,
  onKeyPress,
}: PhoneInputProps) => {
  const {
    countryCode,
    handleCountryCodeChange,
    handleChange,
    maskPhoneNumber,
  } = usePhoneInput({
    onChange,
    defaultCountryId,
  });

  return (
    <HStack gap={2} alignItems="center">
      <SubtleInput
        name={name}
        testID={testID}
        // Mask the phone number
        value={maskPhoneNumber(nationalNumber, countryCode.regionCode) || ""}
        onChange={handleChange}
        isDisabled={isDisabled}
        hasError={hasError}
        placeholder={placeholder}
        inputRef={inputRef}
        keyboardType="phone-pad"
        leftIcon={
          <CountryCodeSelector
            countryCode={countryCode}
            setCountryCode={handleCountryCodeChange}
            variant="subtle"
            countryCodes={CountryCodes}
          />
        }
        onKeyPress={onKeyPress}
      />
    </HStack>
  );
};
